const addressFromForm = ({ formValues, subsidiaries }) => {
    const subsidiary = subsidiaries.find(
        sub => sub.id === formValues.subsidiary
    );
    const country = subsidiary ? subsidiary.country.name : "";

    return `${formValues.address_line_1} ${formValues.address_line_2} ${country}`;
};

const subsidiaryConditions = {
    ES: suggestion => suggestion.address.country === "Spain",
    MX: suggestion => suggestion.address.country === "Mexico",
    KH: suggestion => suggestion.address.country === "Cambodia",
    PH: suggestion => suggestion.address.country === "Philippines",
    IE: suggestion =>
        suggestion.address.country === "Ireland" ||
        suggestion.address.state === "Northern Ireland",
    PT: suggestion => suggestion.address.country === "Portugal",
    NO: suggestion => suggestion.address.country === "Norway",
    USA: suggestion => suggestion.address.country === "United States"
};

export const subsidiaryDenominations = {
    3: value => `${formatNumberWithDot(value)} €`,
    1: value => `P${formatNumberWithComma(value)}`,
    4: value => `${formatNumberWithDot(value)} €`,
    2: value => `P${formatNumberWithComma(value)}`,
    5: value => `${formatNumberWithDot(value)} €`,
    6: value => `${formatNumberWithDot(value)} €`,
    8: value => `$${formatNumberWithComma(value)}`,
    7: value => `${formatNumberWithDot(value)} kr`,
    9: value => `${formatNumberWithDot(value)} $`,
    ES: value => `${formatNumberWithDot(value)} €`,
    MX: value => `P${formatNumberWithComma(value)}`,
    KH: value => `${formatNumberWithDot(value)} €`,
    PH: value => `P${formatNumberWithComma(value)}`,
    IE: value => `${formatNumberWithDot(value)} €`,
    PT: value => `${formatNumberWithDot(value)} €`,
    US: value => `$${formatNumberWithComma(value)}`,
    NO: value => `${formatNumberWithDot(value)} kr`,
    USA: value => `${formatNumberWithDot(value)} $`,
    CA: value => `${formatNumberWithDot(value)} $`
};

function formatNumber(decimalSeparator: string) {
    return function(num: string) {
        return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${decimalSeparator}`);
    };
}

function formatNumberWithComma(num) {
    return formatNumber(",")(num);
}

function formatNumberWithDot(num) {
    return formatNumber(".")(num);
}

const isSuggestionValid = (suggestion, availableSubsidiaries) => {
    return availableSubsidiaries.includes(
        suggestion.address.country_code.toUpperCase()
    );
};

const isSuggestionComplete = suggestion => {
    return (
        suggestion.address &&
        suggestion.address.postcode &&
        suggestion.address.country &&
        suggestion.address.country_code &&
        suggestion.address.road &&
        (suggestion.address.city ||
            suggestion.address.state ||
            suggestion.address.county)
    );
};

const filterSuggestions = ({ suggestions, formValues, subsidiaries }) => {
    let availableSubsidiaries = subsidiaries.map(sub => sub.country.code);

    if (!!formValues.subsidiary) {
        availableSubsidiaries = [
            subsidiaries.find(sub => sub.id === formValues.subsidiary).country
                .code
        ];
    }

    const validSuggestions = suggestions.filter(
        suggestion =>
            isSuggestionValid(suggestion, availableSubsidiaries) &&
            isSuggestionComplete(suggestion)
    );

    return validSuggestions;
};

const addressFromSuggestion = suggestion => {
    const road = suggestion.address.road;
    const number = suggestion.address.house_number;
    const postcode = suggestion.address.postcode;
    const city =
        suggestion.address.city ||
        suggestion.address.state ||
        suggestion.address.county;

    return {
        line1: (road ? road + " " : "") + (number ? number + " " : ""),
        line2: (postcode ? postcode + " " : "") + (city ? city : ""),
        country:
            suggestion.address.country_code === "gb"
                ? "ie"
                : suggestion.address.country_code
    };
};

export const AddressUtils = {
    addressFromForm,
    filterSuggestions,
    addressFromSuggestion
};
